import React from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { Select } from '../../../../../../../../common/react/components/select';
import { getTranslation } from '../../../../../../../../common/react/utils/translations';
import { UPDATE_NAV_ITEM } from '../../../../../../store/js/modules/brownlow-tracker/leaderboard/actions';
import { leaderboardNavSelector } from '../../../../../../store/js/modules/brownlow-tracker/leaderboard/selectors/nav-selector';

export const ClubNavItem = () => {
    const dispatch = useDispatch();
    const nav = useSelector(leaderboardNavSelector);
    const teamsList = useSelector(
        (state) => state.teams[`season_${nav.season.id}`] ?? []
    );

    const teams = [
        { id: -1, name: getTranslation('label.stats.allClubs') },
        ...teamsList.sort((a, b) => (a.name > b.name ? 1 : -1))
    ];

    return (
        <Select
            items={teams}
            itemToString={(team) => team?.name}
            initialSelectedItem={
                teams.length && nav.team.id
                    ? teams.find((t) => t.id === nav.team.id)
                    : ''
            }
            activeItem={
                teams.length && nav.team.id
                    ? teams.find((s) => s.id === nav.team.id)
                    : ''
            }
            onSelectedItemChange={({ selectedItem }) => {
                dispatch(
                    UPDATE_NAV_ITEM.request({
                        navItem: 'team',
                        value: { id: selectedItem.id }
                    })
                );
            }}
            isReadyToRender={() => teams?.length}
            label={getTranslation('label.filters.club')}
        />
    );
};
